/**
 * Addresses that moved, kept working for bookmarks and for links in emails
 * already sent. Each destination does its own role check.
 */

import { Navigate, useLocation, useParams } from "react-router-dom";
import { TICKETS_PATH } from "@/features/admin/ticketsPath";

/** A fixed new address, keeping the navigation state (the page a settings
 *  link was opened from, so its back button still returns there). */
export function KeepStateRedirect({ to }: { to: string }) {
  const { state } = useLocation();
  return <Navigate to={to} state={state} replace />;
}

/** A ticket's former addresses — the Validation group's
 *  `/solutions/validation/tickets/:ticketId` (ADR-0069) and the Solution
 *  settings' tab (ADR-0067), both linked from emails already sent — open the
 *  ticket under Administration (ADR-0076). */
export function LegacyTicketRedirect() {
  const { ticketId = "" } = useParams();
  return <Navigate to={`${TICKETS_PATH}/${encodeURIComponent(ticketId)}`} replace />;
}

/** The Solution settings page that was (ADR-0067, withdrawn by ADR-0069):
 *  Access → Solution access, Support tickets → the tickets, anything else of
 *  Validation → the release validation settings; any other Solution only had
 *  Access. */
export function LegacySolutionSettingsRedirect() {
  const { solution = "", tab = "", itemId } = useParams();
  const { state } = useLocation();
  if (tab === "tickets") {
    const to = itemId ? `${TICKETS_PATH}/${encodeURIComponent(itemId)}` : TICKETS_PATH;
    return <Navigate to={to} replace />;
  }
  if (solution === "validation" && tab !== "access") {
    return <Navigate to="/validation/settings" state={state} replace />;
  }
  return <Navigate to="/admin/solution-access" replace />;
}
